import React from 'react'

export interface Props extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  rows?: number
}
const TextArea: React.FC<Props> = ({ label, rows = 6, ...rest }) => {
  const ref = React.useRef<HTMLTextAreaElement>(null)

  const showLabel = (label && rest.value) || label && ref.current?.value && ref.current?.value?.toString().trim() !== ''
  return (
    <div>
      <div className='relative'>
        {showLabel && <span className='absolute px-5 top-1 text-3xs text-gray'>{label}</span>}
      </div>
      <textarea {...rest} rows={rows} ref={ref} className={`rounded-md w-full ${showLabel ? 'pt-2' : 'py-2.5'} px-5 placeholder:text-gray text-xs sm:text-sm outline-soft-green border-gray-200 border-solid border`} />
    </div>
  )
}

export default TextArea
